import BodyLayout from './bodylayout/BodyLayout.js'
import FilterLayout from './filterLayout/FilterLayout.js'
import LeftAslide from './leftAslide/index.js'
const components = [BodyLayout, FilterLayout, LeftAslide]

var V6ComponentUI = {
  name: 'V6ComponentUI',
}

V6ComponentUI.install = function (Vue) {
  components.map((component) => {
    Vue.use(component)
  })
}

export default V6ComponentUI
